import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import { computed } from 'vue';
import {
  GUIDES_PRODUCT_NAME,
  SNAPLORE_PRODUCT_NAME,
  clearAppContext,
  hasGuidesAccess,
  isGuidesContext,
  isGuidesInLocation,
  isGuidesOnlyCompany,
  paysOnlyForGuides,
} from '@/helpers/appContext';
import { getProductsUrl, getSnaploreAppUrl } from '@/helpers/productsUrl';


export default /*#__PURE__*/_defineComponent({
  __name: 'BackSnaploreButton',
  setup(__props) {

const company = computed(() => store.state.company);

/**
 * A guides checkout must go back to Guides, not the legacy app — otherwise the
 * user is dropped into a product they were not buying (SNAP-2231 QA).
 *
 * Both sources are needed: the plans page runs on the tenant host where the
 * context lives in sessionStorage, while the checkout page runs on the billing
 * host (different origin, empty storage) and carries `?app=guides` in the URL.
 */
const isGuidesJourney = computed(
  () =>
    isGuidesContext() || isGuidesInLocation() || isGuidesOnlyCompany(company.value) || paysOnlyForGuides(company.value)
);

/**
 * SNAP-2231: a company paid for Snaplore only reaches the Guides plans page as an
 * upsell. Sending it "back to Guides" drops it into a product it has not bought,
 * and the products no-access page links straight back here (a loop). Go back to
 * Guides when the company has Guides access OR is entitled to Guides without having Snaplore
 * to go back to (an unpaid Guides buyer is on this page to pay for it, and the legacy app is
 * not where it came from), or when the company is unknown (the session could not be loaded on
 * the billing host).
 */
const isEntitledToGuides = computed(
  () =>
    hasGuidesAccess(company.value) ||
    (company.value?.productAccess?.kb !== true && !!company.value?.enabledProducts?.includes('howto'))
);
const isGuides = computed(() => isGuidesJourney.value && (!company.value || isEntitledToGuides.value));
const label = computed(() => `back to ${isGuides.value ? GUIDES_PRODUCT_NAME : SNAPLORE_PRODUCT_NAME}`);

const handleBackSnaplore = () => {
  // Leaving the billing journey: a Guides context left in sessionStorage would hijack the next
  // company switch (token logins keep it) and upsell or force-redirect the new company.
  clearAppContext();
  window.location.href = isGuides.value
    ? getProductsUrl()
    : getSnaploreAppUrl(company.value?.domain ? company.value.getDomainAddress() : null);
};

return { __sfc: true,company, isGuidesJourney, isEntitledToGuides, isGuides, label, handleBackSnaplore }
}

})